// extracted by mini-css-extract-plugin
export var callout = "framePromoCallout-module--callout--Hdruo";
export var heading = "framePromoCallout-module--heading--1nTaU";
export var text = "framePromoCallout-module--text--TN9DV";